import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CheckIcon from '@material-ui/icons/CheckCircle';

import FMPTextField from '../../components/ui/FMPTextField';
import DeliveryContainer from '../../containers/logistics/StationDelivery';

const styles = (theme) => {
	//const primaryColor = theme.palette.primary[500];
	return {
		note: {
			backgroundColor: '#D8F0FF',
			padding: 20,
			fontSize: 16,
			lineHeight: 1.4,
			marginBottom: 10,
			marginTop: 10,
			border: '1px solid #BADEFB',
		},
		lastChange: {
			//border: '2px solid #bbb',
			//backgroundColor: '#f1f1f1',
			backgroundColor: '#D8F0FF',
			border: '1px solid #BADEFB',
			borderRadius: 4,
			padding: 20,
			fontSize: 16,
			lineHeight: 1.4,
			marginBottom: 10,
			marginTop: 20,
		},
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '20px 30px 30px 30px',
			},
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		orderDetails: {
			paddingTop: 40,
			fontSize: 24,
			fontWeight: 300,
			borderBottom: '1px solid #ddd',
		},
		infoSection: {
			paddingTop: 20,
			lineHeight: 1.4,
		},
		check: {
			color: '#4CAF50',
			width: 40,
			height: 40,
			verticalAlign: 'middle',
			paddingRight: 5,
		},
		confirmedTitle: {
			fontSize: 24,
			fontWeight: 500,
			padding: 20,
		},
		confirmedMessage: {
			padding: 20,
			lineHeight: 1.4,
			fontSize: 16,
		},
	};
};
const formFields = {
	confirmedBy: '',
	carrierPickupWindow: '',
	carrierDeliveryId: '',
	lastChanges: [],
	hasChangeAlert: false,
};

class CarrierConfirmation extends Component {
	constructor(props) {
		super(props);
		const stationDeliveryId = _.get(this.props, ['match', 'params', 'stationDeliveryId']);
		const securityHash = _.get(this.props, ['match', 'params', 'securityHash']);

		this.state = {
			stationDeliveryId: stationDeliveryId ? parseInt(stationDeliveryId, 10) : undefined,
			securityHash,
			errors: [],
			infoSection: undefined,
			formFieldError: {},
		};
		this.state = _.merge(this.state, formFields);

		this.onChange = this.onChange.bind(this);
		this.handleConfirm = this.handleConfirm.bind(this);
	}

	componentDidMount() {
		//- Only used for updates
		const { publicGetDelivery, stationDelivery } = this.props;
		const { stationDeliveryId, securityHash } = this.state;

		if (!stationDelivery) {
			publicGetDelivery({
				params: {
					stationDeliveryId,
					securityHash,
				},
				callback: (err, r) => {
					if (err) {
						return this.setState({ errors: [err] });
					}
					if (!r.infoSection) {
						return this.setState({ errors: ['Missing info section'] });
					}

					return this.setState({ infoSection: r.infoSection });
				},
			});
		}
	}

	//- Is update and get the stationDelivery
	componentDidUpdate(prevProps) {
		const { stationDelivery } = this.props;

		if (_.isUndefined(prevProps.stationDelivery) && stationDelivery) {
			const {
				carrierPickupWindow,
				carrierDeliveryId,
				lastChanges,
				hasChangeAlert,
			} = stationDelivery;

			this.setState({
				carrierPickupWindow,
				carrierDeliveryId,
				lastChanges,
				hasChangeAlert,
			});
		}
	}

	handleConfirm() {
		const { confirmDelivery, showErrors, stationDelivery } = this.props;
		const { stationDeliveryId, securityHash } = this.state;

		const { ethanolCarrierNeedsToProvidePickupWindow, isCancelled } = stationDelivery;

		const requiredFields = [{ display: 'Confirm By', fieldName: 'confirmedBy' }];
		const paramFields = ['confirmedBy', 'carrierDeliveryId'];

		if (ethanolCarrierNeedsToProvidePickupWindow && !isCancelled) {
			requiredFields.push({ display: 'Pickup Window', fieldName: 'carrierPickupWindow' });
			paramFields.push('carrierPickupWindow');
		}

		//- Required fields
		const formFieldError = {};
		requiredFields.forEach((s) => {
			if (!this.state[s.fieldName]) {
				formFieldError[s.fieldName] = `${s.display} is required`;
			}
		});

		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const params = {
			stationDeliveryId,
			securityHash,
		};

		paramFields.forEach((fieldName) => {
			params[fieldName] = this.state[fieldName];
		});
		confirmDelivery({
			params,
		});
	}

	onChange(event, fieldName, index, attr) {
		if (!_.isNumber(index)) {
			this.setState({ [fieldName]: event.target.value });
		} else {
			const inputs = this.state[fieldName].slice();
			if (attr) {
				inputs[index][attr] = event.target.value;
			} else {
				inputs[index] = event.target.value;
			}
			this.setState({ [fieldName]: inputs });
		}
	}

	render() {
		const { classes, stationDelivery, carrierMap } = this.props;

		const { errors, infoSection, lastChanges, hasChangeAlert } = this.state;

		if (errors.length) {
			return (
				<div>
					<div>Encountered an error when retrieving the order</div>
					{errors.map((error, i) => {
						return <div key={i}>{error}</div>;
					})}
					;
				</div>
			);
		}

		if (!stationDelivery) {
			return <div>Fetching delivery information...</div>;
		}
		if (!infoSection) {
			return <div>Fetching info information...</div>;
		}

		const { carrierId, isCancelled, cancellationReason } = stationDelivery;

		const carrier = carrierMap[carrierId];
		if (!carrier) {
			return <div>Carrier {carrierId} not found in the system</div>;
		}

		let title = hasChangeAlert ? 'Change Confirmation' : 'Delivery Confirmation';
		let type = hasChangeAlert ? 'delivery change' : 'delivery request';
		let buttonText = hasChangeAlert ? 'Confirm Change' : 'Confirm Delivery';
		let hasChanges = !!(lastChanges && lastChanges.length);

		if (isCancelled) {
			title = 'Cancellation Confirmation';
			type = 'delivery cancellation';
			buttonText = 'Confirm Cancellation';
			hasChanges = false;
		}

		const { confirmedBy } = stationDelivery;
		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Typography variant="h5" align="left" gutterBottom>
								{title}
							</Typography>
						</Grid>
					</Grid>
					<Paper className={classes.paper}>
						<div className={classes.note}>
							This {type} is intended for <strong>{carrier.name}</strong>. If you have received this
							order in error please contact{' '}
							<a href="mailto:dispatch@pearsonfuels.com">dispatch@pearsonfuels.com</a> or call
							833-385-3835.
							<br />
							<br />
							If you are <strong>{carrier.name}</strong>, please fill out the following information
							and click {buttonText}.
						</div>
						{hasChanges && (
							<div className={classes.lastChange}>
								<ul style={{ padding: 10, margin: 0 }}>
									{lastChanges.map((change, i) => {
										return <li key={i}>{change.display}</li>;
									})}
								</ul>
								<br />
								<div>Please see below for the full details of the order.</div>
							</div>
						)}
						{isCancelled && (
							<div className={classes.lastChange}>
								<strong>
									<span role="img" aria-label="cancel">
										🚫
									</span>{' '}
									Cancellation Reason
								</strong>
								<br />
								{cancellationReason}
								<br />
								<div>Please see below for the full details of the order.</div>
							</div>
						)}

						{!confirmedBy && this.renderForm({ classes, stationDelivery, carrier, buttonText })}
						{confirmedBy && this.renderConfirmed({ classes, stationDelivery, carrier })}

						<div className={classes.infoSection}>
							<div dangerouslySetInnerHTML={{ __html: infoSection }} />
						</div>
					</Paper>
				</Grid>
			</Grid>
		);
	}

	renderForm({ classes, carrier, stationDelivery, buttonText }) {
		const carrierDeliveryIdLabel = `${carrier.name} Delivery ID`;
		const {
			ethanolCarrierNeedsToProvidePickupWindow,
			deliveryWindowStartDateTime,
			isCancelled,
		} = stationDelivery;

		const type = isCancelled ? 'cancellation' : 'delivery';

		const carrierPickupWindowDate = moment(deliveryWindowStartDateTime).format(
			'dddd, MMMM Do, YYYY'
		);
		return (
			<div>
				<FMPTextField
					name={'confirmedBy'}
					label={`Name of individual confirming this ${type}`}
					controller={this}
					helpText={'required'}
				/>

				{ethanolCarrierNeedsToProvidePickupWindow && !isCancelled && (
					<div>
						<div style={{ paddingTop: 10 }}>
							Please provide a pickup window for the terminal on {carrierPickupWindowDate}
						</div>
						<FMPTextField
							name={'carrierPickupWindow'}
							label={'Example : 6am - 9am'}
							controller={this}
							helpText={'required'}
						/>
					</div>
				)}

				<FMPTextField
					name={'carrierDeliveryId'}
					label={carrierDeliveryIdLabel}
					controller={this}
					helpText={'optional'}
				/>

				<div style={{ paddingTop: 20 }}>
					<Button
						variant="contained"
						color="primary"
						className={classes.submitButton}
						onClick={this.handleConfirm}
					>
						{buttonText}
					</Button>
				</div>
			</div>
		);
	}

	renderConfirmed({ classes, carrier, stationDelivery }) {
		const carrierDeliveryIdLabel = `${carrier.name} Delivery ID`;
		const {
			confirmedBy,
			carrierDeliveryId,
			confirmedDateTime,
			carrierPickupWindow,
			isCancelled,
		} = stationDelivery;
		const dateConfirmedFormatted = moment(confirmedDateTime).format(
			'dddd, MMMM Do, YYYY [at] h:mm a'
		);
		const carrierPickupWindowDate = moment(stationDelivery.deliveryWindowStartDateTime).format(
			'dddd, MMMM Do, YYYY'
		);

		//const action = (isCancelled) ? 'cancellation' : 'this delivery';
		const type = isCancelled ? 'cancellation' : 'delivery';

		return (
			<div>
				<div className={classes.confirmedTitle}>
					<CheckIcon className={classes.check} /> This {type} has been successfully confirmed
				</div>
				<div className={classes.confirmedMessage}>
					This {type} was confirmed by <strong>{confirmedBy}</strong> on {dateConfirmedFormatted}.
					{carrierDeliveryId && (
						<div style={{ paddingTop: 10 }}>
							{carrierDeliveryIdLabel} : {carrierDeliveryId}
						</div>
					)}
					{carrierPickupWindow && (
						<div style={{ paddingTop: 10 }}>
							Pickup at terminal on {carrierPickupWindowDate} - {carrierPickupWindow}
						</div>
					)}
				</div>
			</div>
		);
	}
}

CarrierConfirmation.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func,

	confirmDelivery: PropTypes.func.isRequired,
	publicGetDelivery: PropTypes.func.isRequired,
	stationDelivery: PropTypes.object,
	//terminalMap : PropTypes.object,
	carrierMap: PropTypes.object,
	//supplierMap : PropTypes.object,
	//resourceMap : PropTypes.object,
	//stationMap : PropTypes.object,
};

export default _.flow([withStyles(styles), DeliveryContainer])(CarrierConfirmation);
